var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(0.4179688 0.4176941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1694 36.3406C28.2041 36.3406 36.3388 28.2055 36.3388 18.1703C36.3388 8.13513 28.2041 0 18.1694 0C8.13472 0 0 8.13513 0 18.1703C0 28.2055 8.13472 36.3406 18.1694 36.3406Z",
    id: "Oval-3-Copy-17",
    fill: "#706D80",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mail-icon",
    transform: "translate(6.438983 10.06744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.34609C0 1.05991 1.05988 0 2.34609 0L20.0721 0C21.3583 0 22.4182 1.05991 22.4182 2.34609L22.4182 12.7731C22.4182 14.0593 21.3583 15.1192 20.0721 15.1192L2.34609 15.1192C1.05988 15.1192 0 14.0593 0 12.7731L0 2.34609ZM2.54159 1.56406L19.8766 1.56406L11.7223 8.66749C11.4059 8.94277 11.0293 8.94303 10.7122 8.66749L2.54159 1.56406ZM7.09529 7.5922L1.56406 2.78598L1.56406 12.7568L7.09529 7.5922ZM20.8541 2.79406L20.8541 12.7649L15.3392 7.59212L20.8541 2.79406ZM19.4041 13.5551L14.1498 8.61854L12.7487 9.84046C11.8768 10.5991 10.5577 10.5979 9.68574 9.84046L8.2846 8.6267L3.00591 13.5551L19.4041 13.5551Z",
    transform: "translate(0.5213524 0.322678)",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.75980b44651144c165b0be7975345b24.svg";
export { ForwardRef as ReactComponent };